import gql from "graphql-tag";

export const GET_PROVINCE = gql`
  {
    global_provinces(order_by: { name: asc }) {
      id
      code
      name
    }
  }
`;

export const GET_CITY = gql`
  query($prov: Int) {
    global_cities(
      where: { province: { _eq: $prov } }
      order_by: { name: asc }
    ) {
      id
      code
      name
    }
  }
`;
export const ADD_EDUCATION = gql`
  mutation(
    $school: uuid!
    $from: date!
    $to: date
    $is_present: Boolean
    $description: String
    $field_of_study: Int!
    $degree: Int!
  ) {
    insert_people_profile_educations(
      objects: {
        school: $school
        from: $from
        to: $to
        is_present: $is_present
        description: $description
        field_of_study: $field_of_study
        degree: $degree
      }
    ) {
      affected_rows
    }
  }
`;

// export const ADD_EXPERIENCE = gql`
//   mutation(
//     $title: String!
//     $company_name: String!
//     $location: jsonb!
//     $from: date!
//     $to: date
//     $is_present: Boolean!
//     $description: String
//   ) {
//     insert_people_profile_experiences(
//       objects: {
//         title: $title
//         company_name: $company_name
//         location: $location
//         from: $from
//         to: $to
//         is_present: $is_present
//         description: $description
//       }
//     ) {
//       affected_rows
//     }
//   }
// `;
// export const UPDATE_EXPERIENCE = gql`
//   mutation updateExperienceByUser(
//     $title: String!
//     $company_name: String!
//     $location: jsonb!
//     $from: date!
//     $to: date
//     $is_present: Boolean!
//     $description: String
//     $id: Int!
//   ) {
//     update_people_profile_experiences(
//       _set: {
//         title: $title
//         company_name: $company_name
//         location: $location
//         from: $from
//         to: $to
//         is_present: $is_present
//         description: $description
//       }
//       where: { id: { _eq: $id } }
//     ) {
//       affected_rows
//     }
//   }
// `;

export const DELETE_EXPERIENCE = gql`
  mutation($id: Int!) {
    update_people_profile_experiences(
      _set: { deletedAt: "now()" }
      where: { id: { _eq: $id } }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_EXPERIENCE = gql`
  mutation updateExperienceByUser($id:Int!,$object:people_profile_experiences_set_input!){
  update_people_profile_experiences_by_pk(pk_columns:{
    id:$id
  }
    _set:$object
  ){
    id
  }
}
`;

export const SET_SHARE_EXPERIENCE = gql`
  mutation($section: Boolean!, $user: uuid!) {
    a: update_people_profile(
      _delete_key: { settings_section: "experience" }
      where: { id: { _eq: $user } }
    ) {
      affected_rows
    }

    b: update_people_profile(
      _append: { settings_section: "experience" }
      where: { id: { _eq: $user }, _not: { id: { _is_null: $section } } }
    ) {
      affected_rows
    }
  }
`;

export const ADD_EXPERIENCE = gql`
  mutation addExperienceByUser($object:[people_profile_experiences_insert_input!]!){
  insert_people_profile_experiences(
    objects:$object
  ){
    affected_rows
  }
}

`;

export const LIST_CODE_PHONE = gql`
  query getGlobalPhoneCode($search:String){
  global_phone_code(
        order_by: [{country: asc}], 
        where: {
        _or:[
			{
                country:{
                  _ilike:$search
                }
            },
            {
                code:{
                  _ilike:$search
                }
            }
        ]
        }
    ){
    country
    code
  }
}
`;
